<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    color?: string
    title: string
    link?: string | null
    url?: string | null
  }>(),
  { color: 'text-black', link: null, url: null }
)

const computedLink = computed(() => {
  return props.link || props.url
})
</script>

<template>
  <NuxtLink
    class="text-sm leading-7 !no-underline transition hover:text-main-green lg:text-base"
    :class="color"
    :target="url ? '_blank' : undefined"
    :to="computedLink"
  >
    {{ title }}
  </NuxtLink>
</template>
